/* ============================================================
   SUPERLIT SPORT — Theme JavaScript
   CRO-optimised: sticky ATC, countdown, bundle selector, gallery
   ============================================================ */

(function () {
  'use strict';

  /* ---- Utility ---- */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return [...(ctx || document).querySelectorAll(sel)]; }

  /* ---- Header scroll shadow ---- */
  const header = qs('.header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('header--scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  /* ---- Mobile nav toggle ---- */
  const toggle = qs('.header__mobile-toggle');
  const mobileNav = qs('.mobile-nav');
  if (toggle && mobileNav) {
    toggle.addEventListener('click', () => {
      const open = mobileNav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open);
    });
  }

  /* ---- Announcement bar close ---- */
  const announcementClose = qs('.announcement-bar__close');
  if (announcementClose) {
    announcementClose.addEventListener('click', () => {
      const bar = announcementClose.closest('.announcement-bar');
      if (bar) { bar.style.display = 'none'; sessionStorage.setItem('sl_ann_closed', '1'); }
    });
    if (sessionStorage.getItem('sl_ann_closed')) {
      const bar = announcementClose.closest('.announcement-bar');
      if (bar) bar.style.display = 'none';
    }
  }

  /* ---- Product image gallery ---- */
  function initGallery() {
    const thumbs = qsa('.product-gallery__thumb');
    const mainImg = qs('.product-gallery__main img');
    if (!thumbs.length || !mainImg) return;
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        const src = thumb.dataset.src;
        const alt = thumb.dataset.alt || '';
        if (src) {
          mainImg.src = src;
          mainImg.alt = alt;
        }
        thumbs.forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
    if (thumbs[0]) thumbs[0].classList.add('is-active');
  }
  initGallery();

  /* ---- Bundle / quantity selector ---- */
  function initBundleSelector() {
    const options = qsa('.bundle-option');
    if (!options.length) return;
    options.forEach(opt => {
      opt.addEventListener('click', () => {
        options.forEach(o => o.classList.remove('is-selected'));
        opt.classList.add('is-selected');
        const radio = opt.querySelector('.bundle-option__radio');
        if (radio) radio.checked = true;
        // Update sticky ATC price
        const priceEl = qs('.sticky-atc__price');
        const nowEl = opt.querySelector('.price-now');
        if (priceEl && nowEl) priceEl.textContent = nowEl.textContent;
      });
    });
    // Select first by default
    if (options[0]) options[0].click();
  }
  initBundleSelector();

  /* ---- Sticky ATC on product page ---- */
  function initStickyATC() {
    const stickyBar = qs('#sticky-atc');
    const atcBtn = qs('.atc-area .btn--primary');
    const productTitle = qs('.product-info__title');
    const productPrice = qs('.product-info__price .current');
    if (!stickyBar || !atcBtn) return;

    // Populate sticky bar
    stickyBar.innerHTML = `
      <div class="sticky-atc__info">
        <div class="sticky-atc__title">${productTitle ? productTitle.textContent.trim() : ''}</div>
        <div class="sticky-atc__price">${productPrice ? productPrice.textContent.trim() : ''}</div>
      </div>
      <button class="btn btn--primary sticky-atc__btn">Add to Cart 🛒</button>
    `;

    // Show/hide based on ATC button visibility
    const observer = new IntersectionObserver(entries => {
      entries.forEach(e => {
        stickyBar.classList.toggle('is-visible', !e.isIntersecting);
      });
    }, { threshold: 0 });
    observer.observe(atcBtn);

    // Sticky ATC submits main form
    const stickyBtn = stickyBar.querySelector('.sticky-atc__btn');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', () => { atcBtn.click(); });
    }
  }
  if (document.body.classList.contains('template-product')) initStickyATC();

  /* ---- Countdown timer ---- */
  function initCountdown() {
    const timers = qsa('[data-countdown]');
    timers.forEach(timer => {
      const endStr = timer.dataset.countdown;
      if (!endStr) return;
      let endTime;
      // If it's a number, treat as hours from now stored in session
      const hoursKey = 'sl_cd_end_' + endStr;
      const stored = sessionStorage.getItem(hoursKey);
      if (stored) {
        endTime = parseInt(stored, 10);
      } else {
        endTime = Date.now() + parseInt(endStr, 10) * 3600 * 1000;
        sessionStorage.setItem(hoursKey, endTime);
      }

      const hEl = timer.querySelector('[data-hours]');
      const mEl = timer.querySelector('[data-minutes]');
      const sEl = timer.querySelector('[data-seconds]');

      function update() {
        const diff = Math.max(0, endTime - Date.now());
        const h = Math.floor(diff / 3600000);
        const m = Math.floor((diff % 3600000) / 60000);
        const s = Math.floor((diff % 60000) / 1000);
        if (hEl) hEl.textContent = String(h).padStart(2, '0');
        if (mEl) mEl.textContent = String(m).padStart(2, '0');
        if (sEl) sEl.textContent = String(s).padStart(2, '0');
        if (diff <= 0) clearInterval(interval);
      }
      update();
      const interval = setInterval(update, 1000);
    });
  }
  initCountdown();

  /* ---- AJAX Add to Cart ---- */
  function initATC() {
    document.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-atc]');
      if (!btn) return;
      e.preventDefault();
      const form = btn.closest('form[action="/cart/add"]') || btn.closest('.product-form');
      if (!form) return;

      const variantId = form.querySelector('[name="id"]')?.value;
      const qty = form.querySelector('[name="quantity"]')?.value || 1;
      if (!variantId) return;

      btn.disabled = true;
      btn.textContent = 'Adding…';

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: parseInt(qty) })
        });
        if (res.ok) {
          btn.textContent = '✓ Added!';
          btn.style.background = 'var(--color-trust)';
          updateCartCount();
          setTimeout(() => {
            btn.textContent = 'Add to Cart 🛒';
            btn.style.background = '';
            btn.disabled = false;
          }, 2000);
        } else {
          btn.textContent = 'Try again';
          btn.disabled = false;
        }
      } catch {
        btn.textContent = 'Error — try again';
        btn.disabled = false;
      }
    });
  }

  async function updateCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      qsa('.cart-count').forEach(el => { el.textContent = cart.item_count; });
    } catch {}
  }
  initATC();

  /* ---- FAQ accordion (already handled by <details> but add animation) ---- */
  qsa('.faq-item').forEach(item => {
    item.addEventListener('toggle', () => {
      if (item.open) {
        qsa('.faq-item').forEach(other => {
          if (other !== item && other.open) other.open = false;
        });
      }
    });
  });

  /* ---- Smooth scroll for anchor links ---- */
  document.addEventListener('click', e => {
    const a = e.target.closest('a[href^="#"]');
    if (!a) return;
    const target = document.getElementById(a.getAttribute('href').slice(1));
    if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  });

})();
